import React from 'react';
import { Result } from 'antd';

const ResultPage = ({ status, title, subTitle }) => {
  return <Result status={status} title={title} subTitle={subTitle} />;
};

export default ResultPage;
